import React from "react";
import PropTypes from 'prop-types';

const initialState = {
  userID: localStorage.userID || "",
  domain: localStorage.domain || "hq.hk.hld",
  lastCheckTime: localStorage.lastCheckTime || "",
  sessionID: localStorage.sessionID || "",
  curDeptCode: localStorage.curDeptCode || "",

  fullName: localStorage.fullName || "",
  depts: JSON.parse(localStorage.depts || "[]"),

  useCompactMode: localStorage.useCompactMode === "true" || false,

};

export const GlobalState = React.createContext(initialState);

export const GlobalStateProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    (state, newValue) => ({ ...state, ...newValue }),
    initialState
  );
  return (
    <GlobalState.Provider value={[state, dispatch]}>
      {children}
    </GlobalState.Provider>
  );
};


export default GlobalStateProvider;


GlobalStateProvider.propTypes = {
  children: PropTypes.node,
};



const initEvent = {};

export const GlobalEvent = React.createContext(initEvent);

export const GlobalEventProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    (state, newValue) => ({ ...state, ...newValue }),
    initEvent
  );
  return (
    <GlobalEvent.Provider value={[state, dispatch]}>
      {children}
    </GlobalEvent.Provider>
  );
};



GlobalEventProvider.propTypes = {
  children: PropTypes.node,
};

